export default __webpack_public_path__ + "static/GRAIL-logo-e5b3dd6ca2e3c400ae573745ee7ea8a4.png";